import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/linkedin-in': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M100.3 448H7.4V148.9H100.3V448zM53.8 108.1C24.1 108.1 0 83.5 0 53.8S24.1 0 53.8 0 107.6 24.1 107.6 53.8 83.5 108.1 53.8 108.1zM448 448H355.3V302.4C355.3 267.7 354.6 223.2 307 223.2 258.7 223.2 251.3 260.9 251.3 299.9V448H158.5V148.9H247.6V189.7H248.9C261.3 166.2 291.6 141.4 336.8 141.4 430.8 141.4 448.1 203.3 448.1 283.7V448H448z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/linkedin-in.js
// module id = tpuK
// module chunks = 144